module.exports = __webpack_public_path__ + "media/images/emblems/Otelfingen-blazon-50980f45fa32eb890406f46340ec199e.svg";